export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";